import React, { FC } from 'react';
import { IReviewNewProps } from '../../../shared/interfaces/IReviewNew';
import { Box, Typography, useTheme } from '@mui/material';
import ReviewWrapper from '../ReviewWrapper';
import { Person } from '@mui/icons-material';
import DataShakeSummary from '../DataShakeSummary';

interface Props extends IReviewNewProps {}

const TrustedShopsReview: FC<Props> = ({
  commentingModule,
  communityManagement,
  hideHeader,
  hideFooter,
  statusModule,
  status,
  deletionModule,
  reviewEntry,
}) => {
  const theme = useTheme();

  console.log('Trusted reviewEntry', reviewEntry);

  const { username, text, reviewTitle, rating, reviewText } = reviewEntry.review;

  return (
    <ReviewWrapper
      communityManagement={communityManagement}
      commentingModule={commentingModule}
      hideHeader={hideHeader}
      hideFooter={hideFooter}
      rating={rating}
      statusModule={statusModule}
      status={status}
      deletionModule={deletionModule}
      reviewEntry={reviewEntry}
    >
      <DataShakeSummary reviewEntry={reviewEntry} />
    </ReviewWrapper>
  );
};

export default TrustedShopsReview;
